/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPending: {
  name: 'pending';
  data: string;
} = {
  name: 'pending',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM6 13.8C5.004 13.8 4.2 12.996 4.2 12C4.2 11.004 5.004 10.2 6 10.2C6.996 10.2 7.8 11.004 7.8 12C7.8 12.996 6.996 13.8 6 13.8ZM12 13.8C11.004 13.8 10.2 12.996 10.2 12C10.2 11.004 11.004 10.2 12 10.2C12.996 10.2 13.8 11.004 13.8 12C13.8 12.996 12.996 13.8 12 13.8ZM18 13.8C17.004 13.8 16.2 12.996 16.2 12C16.2 11.004 17.004 10.2 18 10.2C18.996 10.2 19.8 11.004 19.8 12C19.8 12.996 18.996 13.8 18 13.8Z"/></svg>`,
};
